import { Injectable } from '@angular/core';
import {Country} from './country';
import { CONFIG } from '../../../shared/config';
import {   HttpGeneralService } from '../../../shared';
let countriesUrl = CONFIG.baseUrls.countries;
@Injectable()
export class CountryService {
    constructor(private httpGeneralService: HttpGeneralService ) {}
    getCountries() {
      return this.httpGeneralService.getWith(`${countriesUrl}/all`);
          }

    searchCountries(k?: string) {
        let keyword = k || " ";
        return this.httpGeneralService.getWith(`${countriesUrl}/search/${keyword}`);
    }

    search(k?: string) {
        let keyword = k || " ";
        return this.httpGeneralService.getWith(`${countriesUrl}/search/${keyword}`);
    }
    addCountry(country: Country) {
        return this.httpGeneralService.add<Country>(country, countriesUrl)
    }
    getCountry(id: number) {
        return this.httpGeneralService.get(id, countriesUrl)
    }
    updateCountry(country: Country) {
        return this.httpGeneralService.update<Country>(country.code, country, countriesUrl)
    }
    deleteCountry(country: Country) {
        return this.httpGeneralService.delete<number>(country.code, `${countriesUrl}`)
    }
}
